module.exports = __webpack_public_path__ + "img/eagle.5d93e8b.svg";